import styled from 'styled-components'


export const FormWrapper = styled.div`
  position: relative;
`
export const Loading = styled.div`
  position: absolute;
  top: 0rem;
  left: -1rem;
  right: -1rem;
  bottom: -1rem;
  z-index: 3;
  display: flex;
  background: white;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
  color: ${props => props.theme.colors.primary};
`


export const Thankyou = styled.div`
  height: 50vh;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  flex-direction: column;

  *{

  font-size: 1.25rem;
  }
  span {
    color: ${props => props.theme.colors.primary};
  }
  strong {
    font-weight: 600;
  }
`